$(function () {

    // Scroll to top
    $('#footer-go-top').click(function(){
        scrollToTop();
    });

});

addEventListener('scroll', function(){
    (window.scrollY > 50) ? $('#footer-go-top').css('display', 'block') : $('#footer-go-top').css('display', '');
}, true);

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}
